{
  "maximum": "מקסימום",
  "minimum": "מינימום"
}
